// Base plugin interface and types
export { BasePlugin } from './base';
// WebAuthn plugin exports
export { Webauthn } from './webauthn/webauthn';
export { WebauthnPlugin } from './webauthn/webauthnPlugin';
// Ethereum plugin exports
export { Web3Connector } from './web3/web3Connector';
export { Web3ConnectorPlugin } from './web3/web3ConnectorPlugin';
// Bitcoin plugin exports
export { NostrConnector } from './nostr/nostrConnector';
export { NostrConnectorPlugin } from './nostr/nostrConnectorPlugin';
// Challenge-Response plugin exports
export { ChallengePlugin } from './challenge/challengePlugin';
